<template>
  <div class="EipManage">
    <WujieVue
      width="100%"
      height="100%"
      name="EipManage"
      :url="url"
      :plugins="plugins"
      :props="propsData"
      :alive="true"
      :timeout="60000"
    ></WujieVue>
  </div>
</template>

<script>
import hostMap from '../../../wujie-config/hostMap'
import wujieVue from 'wujie-vue2'
import { mapState } from 'vuex'

export default {
  data() {
    return {
      plugins: [
        {
          // 在子应用所有的css之前
          cssBeforeLoaders: [
            // 强制使子应用body定位是relative
            {
              content:
                'body{position: relative !important;} body #app {background-color: #fff !important;} .el-popper{position:absolute !important;} .el-popup-parent--hidden{overflow: visible !important;}'
            }
          ]
        },
        // js 脚本将由子应用自行加载
        // TODO vue-amap是通过appendChild(script)请求js的，在无界中defer和async失效，导致会阻塞进程，先改为不加载
        { jsExcludes: [].concat(window.config.useAMap ? [] : [/webapi\.amap\.com\/maps/]) },
        {
          jsLoader: (code, url) => {
            if (/chunk-elementUI.*\.js/.test(url)) {
              // // 替换popper.js内计算偏左侧偏移量
              // const codes = code.replace(
              //   'left: elementRect.left - parentRect.left',
              //   'left: fixed ? elementRect.left : elementRect.left - parentRect.left'
              // )
              // 替换popper.js内右侧偏移量
              code = code
                .replace('popper.right > data.boundaries.right', 'false')
                .replace('n.right>e.boundaries.right', 'false')
            } else if (/ueditor.all.min.js/.test(url)) {
              // 修复ueditor报错问题
              code = code
                .replace(
                  'window.parent.UE',
                  "window.parent.document.querySelector('iframe[name=EipManage]').contentWindow.UE"
                )
                .replace(
                  'function updateFixedOffset() {',
                  'window.parent[magic]=window[magic];function updateFixedOffset() {'
                )
            }
            return code
          }
        }
      ]
    }
  },
  computed: {
    ...mapState('sys', ['token','logo', 'tenantCode', 'tenantId', 'currentUser', 'ssoConfig']),
    ...mapState('menu', ['menuList']),
    url() {
      return hostMap('eipManageUrl') + this.$route.path
    },
    propsData() {
      return {
        token: this.token,
        logo: this.logo,
        tenantCode: this.tenantCode,
        tenantId: this.tenantId,
        currentUser: this.currentUser,
        menuList: this.menuList,
        ssoConfig: this.ssoConfig
      }
    }
  },
  watch: {
    '$route.params': {
      handler: function () {
        wujieVue.bus.$emit('EipManage-router-change', this.$route.path.replace('/eipManage', ''))
      },
      immediate: true
    }
  },
  mounted() {
    console.log('1.子应用容器就绪：' + new Date())
  },
  methods: {
    jump(name) {
      this.$router.push({ name })
    }
  }
}
</script>

<style scoped>
.EipManage {
  padding: 10px 20px;
  background-color: #fff;
  height: 100%;
}
</style>
